module.exports = __webpack_public_path__ + "static/media/generalCard1.2a8ae45b.svg";